import React from 'react';
import { sprintf } from 'sprintf-js';
import { SignalStrengthHelper } from "../../helpers";
import i18next from "i18next";
import { DeviceDataOverrideService } from '../../services';

const DataTypeDisplayValue = ({value, measureName, deviceTypeToken, displayLabel}) => {
  if (value) {
    var rawValue = null;
    if (value.stringValue != null) {
      rawValue = value.stringValue;
    } else if (value.numericValue != null) {
      rawValue = value.numericValue;
    } else if (value.booleanValue != null) {
      rawValue = value.booleanValue;
    }
    var displayValue = "" + rawValue;

    const finalDeviceTypeToken = deviceTypeToken || value.deviceDataType?.token;

    const potentialTranslatedValue = `data-string-display.${finalDeviceTypeToken}.${rawValue}`;
    if (i18next.t(potentialTranslatedValue) !== potentialTranslatedValue) {
      displayValue = i18next.t(potentialTranslatedValue);
    } else if (finalDeviceTypeToken === 'rssi') {
      displayValue = `${rawValue} (${SignalStrengthHelper.renderRSSIValue(rawValue, deviceTypeToken)})`;
    } else if (finalDeviceTypeToken === 'cell_rsrp') {
      displayValue = `${rawValue} (${SignalStrengthHelper.renderLTERSRPValue(rawValue)})`;
    } else if (finalDeviceTypeToken === 'cell_rsrq') {
      displayValue = `${rawValue} (${SignalStrengthHelper.renderLTERSRQValue(rawValue)})`;
    } else if (finalDeviceTypeToken === 'cell_sinr') {
      displayValue = `${rawValue} (${SignalStrengthHelper.renderLTESINRValue(rawValue)})`;
    } else if (finalDeviceTypeToken === 'cell_rssi') {
      displayValue = `${rawValue} (${SignalStrengthHelper.renderLTERSSIValue(rawValue)})`;      
    } else if (finalDeviceTypeToken === 'geo_lat_lon') {
      displayValue = sprintf('%0.2f, %0.2f', value.complexValue.latitude, value.complexValue.longitude);
    } else if (finalDeviceTypeToken === 'magnetometer') {
      displayValue = i18next.t(`magnetometer-data-string-display.${rawValue}`);
    } else if (finalDeviceTypeToken === 'door_state') {
      displayValue = i18next.t(`door-state-data-string-display.${rawValue}`);
    } else if (finalDeviceTypeToken === 'power_status') {
      displayValue = i18next.t(`power-status-data-string-display.${rawValue}`);
    }  else if (value.displayFormat) {
      displayValue = sprintf(DeviceDataOverrideService.getOverrideForDisplayFormat(value.displayFormat), rawValue);
    } else {
      const ddtStateValue = i18next.t(`device-data-types.state-values.${value.deviceDataType.token}.${rawValue}`);
      if (ddtStateValue != `device-data-types.state-values.${value.deviceDataType.token}.${rawValue}`) {
        displayValue = ddtStateValue;
      }
    }

    if (displayLabel) {
      return (
        <>
          <div className='measurement-type'>{measureName || value.deviceDataType.name}:</div> 
          <div className='measurement-value'>{displayValue}</div>
        </>
      );
    } else {
      return (<span>{displayValue}</span>);
    }
  } else {
    return (
      <span>{ i18next.t('unknown') }</span>
    );
  }
};

export default DataTypeDisplayValue;
